<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
        this.promiseAll();
		this.handleGetUserList();
		// this.getCityList({threeLevel: false});
	},
	data() {
		return {
			authOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					phone: '',
                    queryTimeBegin: '',
                    queryTimeEnd: ''
				},
			},
			selectOption: {
				// provinceId: [],
				// cityId: [],
				// vip: [{value: 0, label: '否'}, {value: 1, label: '是'}],
				// status: [{value: 0, label: '停用'}, {value: 1, label: '启用'}],
                authStatus: []

			},
			codeDetail: {},
			dialogOption: {
				width: '40%',
				title: '跟进状态',
				type: 1, // 0新增， 1编辑
				show: false
			}
		}
	},
	methods: {
		// 获取选择项
		// async handleDelete(row){
        //     this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         this.delete(row);
        //     })
		// },
        // async delete(row) {
        //     const id = row.id;
		// 	const {code} = await this.textDel({id});
		// 	if (Object.is(code, 200)) {
		// 		this.$message.success('删除成功');
		// 		this.handleGetUserList();
		// 	}
        // },
        // 获取选择项
        promiseAll() {
            Promise.all([this.followType()]).then(res => {
                this.selectOption.authStatus = res[0].data || [];
            });
        },
		handleEdit(row, type, title) {
			this.codeDetail = row;
			this.dialogOption.type = type;
			this.dialogOption.title = title;
			this.dialogOption.show = true;
			this.$nextTick(()=> {
				this.$refs.edit.modelStatus(true);
			});
		},
		async handleGetUserList() {
			this.$loading(true);
			const {pageQuery, searchQuery} = this.authOption;
			const {pageSize, currentPage}  = pageQuery;
			try {
				const {code, data} = await this.purchaseApply({
					...searchQuery, pageSize, currentPage
				});
				this.authOption.data = data && data.dataSource || [];
				this.authOption.pageQuery.total = data && data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		skipPage({id}) {
			this.$router.push({
				path: `/policy/country/detail/${id}`,
				query: {
					event: 'getTextDetail'
				}
			})
		},
		change({value, type}) {
			this.authOption.pageQuery.currentPage = 1;
			// if (Object.is(type, 'provinceId')) {
			// 	this.authOption.searchQuery.cityId = '';
			// 	this.selectOption.cityId = this.setCity(value);
			// }
		},
		setCity(val) {
			return this.cityList.filter(item => item.parentId === val);
		},
		...mapActions('zft',['purchaseApply', 'purchaseFollowType', 'getCityList', 'followType'])
	},
	computed: {
		...mapGetters('zft', ['cityList']),

		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	},
	// watch: {
	// 	'cityList': function() {
	// 		this.selectOption.provinceId = this.cityList.filter(item => item.parentId === 0);
	// 	}
	// }
}
</script>
<template>
<div class="rule-list">
	<top-bar
	  :handlerCodeSearch="handleGetUserList"
	  :searchQuery="authOption.searchQuery"
	  :selectOption="selectOption"
	  @change="change"
	></top-bar>
    <code-table
     :data="authOption.data"
     :columns="columns.orderMallColumns"
     :searchEvent="handleGetUserList"
     :pageOptions="authOption.pageQuery"
    >
        <el-table-column label="操作" align="center" width="80" slot="operate">
            <template slot-scope="scope">
	            <el-button type="success"  @click="handleEdit(scope.row, 2, '跟进')">跟进</el-button>
	        </template>
        </el-table-column>
    </code-table>
    <edit ref="edit"
	  :dialogOption="dialogOption"
	  :codeEvent="purchaseFollowType"
	  :searchEvent="handleGetUserList"
	  :codeDetail="codeDetail"
	  :selectOption="selectOption"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
